import {Injectable} from "@angular/core";
import {MenuTreeItem, UnterstuetzungMenuTreeItem} from "./menu-tree-item";
import {MenuItemRouteMapping} from "./menu-item-route-mapping";
import {TranslateService} from "@ngx-translate/core";
import {MenuItem} from "app/core/services/menu/menu-item";
import {LinkConfigEntry, MenuConfigEntry} from "app/core/base-api";

@Injectable()
export class MenuTreeService {

  constructor(private translateService: TranslateService) {
  }

  static getChildren(currentParent: MenuConfigEntry.ParentEnum, menuConfig: MenuConfigEntry[]): Array<MenuTreeItem> {
    const children: Array<MenuTreeItem> = [];
    menuConfig.filter(o => o.parent === currentParent).forEach(function (entry: MenuConfigEntry) {
      const displayItem = MenuItemRouteMapping.availableMenuDisplayItems.filter(m => m.element === entry.element)[0];
      if (displayItem) {
        const item = new MenuTreeItem(MenuTreeService.getChildren(entry.element, menuConfig), displayItem, entry.orderIndex, entry.deactivated);
        item.deactivated = item.deactivated || (item.children && item.children.length > 0 && item.children.every(a => a.deactivated));
        children.push(item);
      }
    });
    children.sort(MenuTreeItem.orderCompare);
    return children;
  }

  create(menuConfig: Array<MenuConfigEntry>): MenuTreeItem {
    return new MenuTreeItem(MenuTreeService.getChildren('MENU_ROOT', menuConfig), null);
  }

  createUpdateableMenu(entries: Array<LinkConfigEntry>, order: number, rootItem: MenuItem): MenuTreeItem {
    const children: Array<MenuTreeItem> = [];
    entries.forEach(entry => children.push(new UnterstuetzungMenuTreeItem(entry, this.translateService)));
    children.sort(MenuTreeItem.orderCompare);
    return new MenuTreeItem(children, rootItem, order, false);
  }
}
